import Vue from 'vue'
import Meta from 'vue-meta'
Vue.use(Meta)
import VueMoment from './teras/vue-moment'
Vue.use(VueMoment,'it')
import App from './App'




//import router from './router'
require('es6-promise').polyfill();


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/it'
Vue.use(ElementUI, { locale })

import './css/big.css'
/* Inizio Router */
import router from'./router'
/* Fine Router */

import contatto from './teras/contatto'



import teras from './teras'
import axios from './teras/axios'

//import VueAnalytics from 'vue-analytics'
//const googleAnalyticsId = 'UA-2826949-6'
//Vue.use(VueAnalytics, { id: googleAnalyticsId, router: router })


import lang from './teras/tLang'
Vue.prototype.$lang = lang

Vue.config.productionTip = false
if(process.env.NODE_ENV != 'development') 
  console.log = function() {}


     




teras.event.on('routerFirst', function(to) {

  console.log(teras.app.device)
  let anni = (teras.app.device=='mobile') ? 1 : 2
  axios.query('fetchAll',`SELECT 
    ev.id AS id, ev.titolo, ev.sottotitolo, ev.iniziail, ev.finisceil, ev.tipologiaformazione, ev.crediti, ev.idfad, ev.linkcomplete
    , ev.provider, provider.nome AS providernome, provider.numero AS providernumero
    , ev.responsabile, ev.responsabileemail, ev.respscientifico
    , es.imgslide, es.imgslidepubblicata AS imgslidepubblicata, es.imgcitta, es.imglogo, es.linkprogramma, es.emailprenotazioni, es.linkgalleria, es.statoevento AS statoevento, es.atti AS atti
    , ev.interesse AS interesse
    , IF(GROUP_CONCAT(DISTINCT interesse.macroarea)='1,2', '1',GROUP_CONCAT(DISTINCT interesse.macroarea)) AS macroarea
    , ev.citta as citta
    , tpse.tipopulsante AS tpsetipo

    , abs.id AS abs, es.linkabstract AS abslink
    , ev.apertoaziende AS apertoaziende
    , es.personalizzatolink AS personalizzatolink, es.personalizzatolabel AS personalizzatolabel
    , GROUP_CONCAT(DISTINCT categoria.nome SEPARATOR ', ') AS categorie



    , IF(YEAR(ev.iniziail)>YEAR(NOW())-1,es.htmlquote, '') AS htmlquote, IF(YEAR(ev.iniziail)>YEAR(NOW())-1,es.htmlinfo, '') AS  htmlinfo
    , tpse.nomepulsante AS tpsenomeit, tpse.titoloarea AS tpsetitoloit, tpse.testoarea AS tpsemoreit

    , IF(YEAR(ev.iniziail)>YEAR(NOW())-1,es.htmlquoteeng, '') AS htmlquoteeng, IF(YEAR(ev.iniziail)>YEAR(NOW())-1,es.htmlinfoeng, '') AS htmlinfoeng
    , tpse.nomepulsanteeng AS tpsenomeen, tpse.titoloareaeng AS tpsetitoloen, tpse.testoareaeng AS tpsemoreen
    
    FROM evento AS ev
    LEFT JOIN eventosito AS es ON es.id=ev.id
    LEFT JOIN provider ON provider.id=ev.provider
    LEFT JOIN interesse ON FIND_IN_SET(interesse.id,ev.interesse)
    LEFT JOIN categoria ON FIND_IN_SET(categoria.id,ev.categorie)
    LEFT JOIN tipositostatoevento AS tpse ON tpse.id=es.statoevento
    LEFT JOIN bm_bams.evento AS abs ON abs.bvent=ev.id
    WHERE ((ev.tipologiaformazione!=1 AND YEAR(ev.iniziail)>YEAR(NOW())-`+anni+` AND tpse.tipopulsante != 99) or (ev.tipologiaformazione=1 AND tpse.tipopulsante != 99)) 
    GROUP BY ev.id ORDER BY ev.iniziail ASC LIMIT 500`,{},teras,'_evento',true,true).then((response) =>  {

    
    
      axios.query('fetchAll',`call evento_interesse_next('all')`,{},teras,'_nextevento',true,true)
      axios.query('fetchAll',`SELECT i.* FROM evento AS ev LEFT JOIN interesse AS i ON FIND_IN_SET(i.id,ev.interesse) WHERE i.id IS NOT NULL GROUP BY i.id ORDER BY i.nome`,{},teras,'_interesse',true,true)
      axios.query('fetchAll',`SELECT * FROM provider WHERE id >0`,{},teras,'_provider',true,true)
      axios.query('fetchAll','SELECT id,iso,iso3,codice,nome,nomeeng,UE AS ue FROM codicefiscale.nazione WHERE iso3!=\'\' ORDER BY nomeeng',{},teras,'_nazione',true,false)
      axios.query('fetchAll','SELECT id,provincia,nome FROM comune WHERE 1 ORDER BY nome',{},teras,'_comune',true,false)
      axios.query('fetchAll',"SELECT sigla,nome FROM provincia WHERE id>0 AND sigla !='' ORDER BY nome",{},teras,'_provincia',true,false)



      if(teras.exist('utente')){
        console.log("YES, PRESENTE UTENTE IN LOCAL STORAGE....LO RICARICO DA LI")
        console.log("TERAS APP STEP IS NOW "+teras.app.step)
        teras.utente = teras.load('utente')
        teras.app.auth = true
        teras.event.emit('afterlogin')
        teras.app.routeInitial = to.path 
        
    }else{
        console.log("Aggiungo +1 per il controllo del utente")
        teras.app.step++
        console.log("TERAS APP STEP IS NOW "+teras.app.step)
        teras.app.routeInitial = to.path
    }

    teras.app.step = 1

})
 //teras.app.ready = true
})
/* Quando voglio che vengano pulite le variabile salvate in storage */
teras.event.on('appClear', function() {
  console.log("RIMUOVO _evento")
  teras.remove('_evento')
  if(!teras.exist('_evento'))
    console.log("RIMOSSO _evento")

  teras.remove('_nextevento')
  teras.remove('_interesse')
  teras.remove('_provider')
})

teras.event.on('appReady', function() {
  console.log("appReady appReady appReady appReady appReady appReady appReady")
  //router.push((teras.app.auth) ? '/home' : teras.app.routeInitial)
  router.push(teras.app.routeInitial)
})
teras.event.on('routerNoauth', function() {
})
teras.event.on('afterlogin', function() {
  contatto.load(teras.utente.id).then((data) => {
    teras.app.step++
    console.log("*****************************************************+")
  })
})
teras.event.on('logout', function() {
  console.log("ESCO DA MYLOGIN")
  teras.remove('utente')
  teras.utente = {}
  teras.app.auth = false
  router.replace('/mylogin')
})
teras.event.on('appExit', function() {
})

console.log("AFTER teras.event.on")

/*
axios.query('fetchAll',`SELECT cat.*,count(*) AS numeventi
  FROM evento AS ev 
  LEFT JOIN categoria AS cat ON FIND_IN_SET(cat.id,ev.categorie) 
  WHERE cat.id IS NOT NULL AND cat.id!=90 AND YEAR(ev.iniziail)>YEAR(NOW())-1
  GROUP BY cat.id order by cat.nome`,{},teras,'_categoria').then((response) =>  {
  //teras.app.step++
})

axios.query('fetchAll',`SELECT dsp.*,count(*) AS numeventi
  FROM evento AS ev 
  LEFT JOIN categoria AS dsp ON FIND_IN_SET(dsp.id,ev.discipline) 
  WHERE dsp.id IS NOT NULL AND YEAR(ev.iniziail)>YEAR(NOW())-1
  GROUP BY dsp.id order by dsp.nome`,{},teras,'_disciplina').then((response) =>  {
  //teras.app.step++
})

axios.query('fetchAll',`SELECT its.*,count(*) AS numeventi
  FROM evento AS ev 
  LEFT JOIN interesse AS its ON FIND_IN_SET(its.id,ev.interesse) 
  WHERE its.id IS NOT NULL AND YEAR(ev.iniziail)>YEAR(NOW())-1
  GROUP BY its.id order by its.nome`,{},teras,'_interesse').then((response) =>  {
  //teras.app.step++
})
 */   
/*
axios.email({from:'mirko.c@terasonline.com',oggetto:'La mia prima email....'}).then((data) => {
  console.log("EMAIL EMAIL EMAIL")
  console.log(data)
}).catch((error) => {
  console.log("ERRORE NELL'INVIO DELLA EMAIL")
  console.log(error)
})
*/

Vue.prototype.$teras = teras
//Vue.prototype.$moment = teras.moment
Vue.prototype.axios = axios
Vue.prototype.$contatto = contatto
new Vue({
  el: '#app',
  router,
  data:{
    teras
    ,axios
    ,contatto
    ,lang
  },
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js